import { FiberManualRecordRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import EyeBrow from 'component/MarketPlace/eyeBrow/eyeBrow';
import React from 'react';
import { convertNumberToCurrency } from 'utils/functions';

export interface CardPriceProps {
  price?: {
    current?: number;
    msrp?: number;
    low_stock?: boolean;
  };
  currency?: string;
  showPrice?: boolean;
}

const CardPrice = (props: CardPriceProps) => {
  const { price = {}, currency, showPrice = true } = props;

  const convertPrice = (price: number) => {
    return convertNumberToCurrency(price, currency);
  };

  const checkShowPrice = (price?: number) => {
    if (!showPrice) return false;
    return typeof price === 'number';
  };

  return (
    <Box>
      {checkShowPrice(price.msrp) && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textDecorationLine: 'line-through' }}
        >
          {convertPrice(price.msrp!)}
        </Typography>
      )}

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        {checkShowPrice(price.current) && (
          <Typography variant="h5">{convertPrice(price.current!)}</Typography>
        )}

        {price.low_stock && (
          <EyeBrow
            label="LOW STOCK"
            variant="outlined"
            startIcon={<FiberManualRecordRounded />}
            color="warning"
            sx={{ fontWeight: 600, border: 0, p: 0 }}
          />
        )}
      </Stack>
    </Box>
  );
};

export default CardPrice;
